import { render, staticRenderFns } from "./BandwithChart.vue?vue&type=template&id=666f6519&scoped=true&"
import script from "./BandwithChart.vue?vue&type=script&lang=js&"
export * from "./BandwithChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666f6519",
  null
  
)

export default component.exports